import { Injectable } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { PaymentEnum } from "../enum/utilities/payment.enum";

@Injectable()
export class PaymentMethodLabelService {
  constructor(private _translateService: TranslateService) {}

  translatePaymentMethod(payment: PaymentEnum): string {
    return this._translateService.instant(payment ? payment : '');
  }
}
